exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/variables.css"), "");

// module
exports.push([module.id, ".avatar_ef6 {\n  -o-object-fit: contain;\n     object-fit: contain;\n  -o-object-position: center;\n     object-position: center;\n\n  border-radius: 3px;\n\n  border-radius: var(--ring-border-radius); /* This is a \"graceful degradation\" fallback, while the real value is controlled by JS */\n}\n\n.empty_1c2 {\n  display: inline-block;\n\n  -webkit-box-sizing: border-box;\n\n          box-sizing: border-box;\n\n  border: 1px solid #b8d1e5;\n\n  border: 1px solid var(--ring-borders-color);\n}\n", ""]);

// exports
exports.locals = {
	"avatar": "avatar_ef6",
	"empty": "empty_1c2"
};